import { registerStyles } from '@vaadin/vaadin-themable-mixin/register-styles.js';
import { progressBarStyles } from './vaadin-progress-bar-css';
registerStyles('vaadin-progress-bar', progressBarStyles, { moduleId: 'lumo-progress-bar' });
//# sourceMappingURL=vaadin-progress-bar-styles.js.map